import type { AnalysisFieldChange } from "./contracts";
export type { AnalysisFlag } from "./contracts";
export const uncertainFlagMessage = "Не удалось подтвердить сохранение. Требуется обновить список";

export function isMetadataAcknowledgement(value: unknown, problemId: number, intent: AnalysisFieldChange): boolean {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const body = value as Record<string, unknown>;
  return Object.keys(body).length === 2 && Object.hasOwn(body, "problemId") && Object.hasOwn(body, intent.field) &&
    Number.isSafeInteger(body.problemId) && body.problemId === problemId && problemId > 0 && body[intent.field] === intent.value;
}

const errors = {
  "invalid-request": { status: 400, message: "Не удалось сохранить изменение: некорректный запрос" },
  unauthenticated: { status: 401, message: "Требуется повторная проверка входа" },
  forbidden: { status: 403, message: "Не удалось подтвердить доступ" },
  "not-found": { status: 404, message: "Партия недоступна. Обновите список" },
  "method-not-allowed": { status: 405, message: "Не удалось сохранить изменение" },
  conflict: { status: 409, message: "Изменение не сохранено из-за конфликта. Повторите попытку" },
  "request-too-large": { status: 413, message: "Не удалось сохранить изменение: запрос слишком большой" },
  "unsupported-media-type": { status: 415, message: "Не удалось сохранить изменение: неподдерживаемый формат" },
  "save-failed": { status: 500, message: "Не удалось сохранить изменение. Повторите попытку" },
  "outcome-unknown": { status: 500, message: uncertainFlagMessage },
} as const;

export function readFlagError(status: number, value: unknown) {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return;
  const body = value as Record<string, unknown>;
  if (typeof body.code !== "string" || typeof body.message !== "string" || !Object.hasOwn(errors, body.code)) return;
  const code = body.code as keyof typeof errors;
  const error = errors[code];
  if (error.status === status) return { code, message: error.message };
}
